import { render, staticRenderFns } from "./Straight.vue?vue&type=template&id=5f29ebe8&scoped=true"
import script from "./Straight.vue?vue&type=script&lang=js"
export * from "./Straight.vue?vue&type=script&lang=js"
import style0 from "./Straight.vue?vue&type=style&index=0&id=5f29ebe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f29ebe8",
  null
  
)

export default component.exports